var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.961426H513V342.954H0V0.961426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 112.483H513V231.432H0V112.483Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 231.433H513V342.954H0V231.433Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.721 97.6118V182.914C129.721 231.438 193.111 246.305 193.111 246.305C193.111 246.305 256.5 231.436 256.5 182.914V97.6118H129.721Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.411 100.112V182.213C146.411 187.696 147.628 192.874 150.041 197.728H236.179C238.592 192.875 239.809 187.697 239.809 182.213V100.112H146.411Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.733 157.357H200.266V143.046H214.578V128.735H200.266V114.423H185.955V128.735H171.645V143.046H185.955V157.357H164.487V171.668H185.955V185.979H200.266V171.668H221.733V157.357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.563 217.705C178.785 223.499 188.259 226.866 193.111 228.362C197.962 226.865 207.437 223.5 216.659 217.705C225.959 211.861 232.48 205.175 236.181 197.727C231.959 194.734 226.91 193.129 221.735 193.135C219.775 193.135 217.871 193.368 216.042 193.793C212.163 184.98 203.359 178.824 193.113 178.824C182.866 178.824 174.063 184.98 170.184 193.793C168.318 193.357 166.408 193.136 164.491 193.135C159.316 193.129 154.267 194.734 150.045 197.727C153.743 205.175 160.263 211.861 169.563 217.705Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.95752)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSk);
export default __webpack_public_path__ + "static/media/SK.53d173c6130e4cebf748a281e83d0997.svg";
export { ForwardRef as ReactComponent };